import { render, staticRenderFns } from "./SectionUserContainer.vue?vue&type=template&id=6d512156&scoped=true"
import script from "./SectionUserContainer.vue?vue&type=script&lang=js"
export * from "./SectionUserContainer.vue?vue&type=script&lang=js"
import style0 from "./SectionUserContainer.vue?vue&type=style&index=0&id=6d512156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d512156",
  null
  
)

export default component.exports